import { Typography } from '@/components/common';
import { InputRadioBgIcon } from '@/components/form';
import { errorFieldMessage } from '@/const';
import * as React from 'react';
import {
	FieldErrors,
	FieldValues,
	UseFormGetValues,
	UseFormRegister,
	UseFormSetValue,
} from 'react-hook-form';

interface ClosedQuestionI {
	index: number;
	register: UseFormRegister<FieldValues>;
	getValues: UseFormGetValues<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	errors: FieldErrors<FieldValues>;
	disabled?: boolean;
}

export const ClosedQuestion: React.FC<ClosedQuestionI> = ({
	index,
	getValues,
	register,
	setValue,
	errors,
	disabled,
}) => {
	const [expectedAnswer, setExpectedAnswer] = React.useState<
		'YES' | 'NO' | 'BOTH' | undefined
	>(getValues(`questions[${index}].expected_answer`) || undefined);

	const rules = {
		expected_answer: {
			required: { value: true, message: errorFieldMessage },
		},
	};

	const handleSetExpectedAnswer = (
		answer: 'YES' | 'NO' | 'BOTH' | undefined
	): void => {
		setExpectedAnswer(answer);
		setValue(`questions[${index}].expected_answer`, answer || null);
	};

	return (
		<div className="w-full h-full">
			<div className="space-y-4 mt-6">
				<Typography type="regular-16">
					{expectedAnswer ? 'Correct answer' : 'Select the correct answer'}
				</Typography>
				<InputRadioBgIcon
					disabled={disabled}
					name={`questions[${index}].expected_answer`}
					id={`questions[${index}].expected_answer`}
					value="YES"
					register={register}
					onChangeCustom={() => {
						if (expectedAnswer) {
							if (expectedAnswer === 'NO') {
								handleSetExpectedAnswer('BOTH');
							} else if (expectedAnswer === 'BOTH') {
								handleSetExpectedAnswer('NO');
							} else {
								handleSetExpectedAnswer(undefined);
							}
						} else {
							handleSetExpectedAnswer('YES');
						}
					}}
					bgIcon={
						expectedAnswer &&
						(expectedAnswer === 'YES' || expectedAnswer === 'BOTH')
							? 'check'
							: undefined
					}
					className="group"
					classNameButton={
						'group-hover:disabled:bg-[#F4F4F4A3] disabled:!cursor-not-allowed'
					}
				>
					Yes
				</InputRadioBgIcon>
				<InputRadioBgIcon
					disabled={disabled}
					name={`questions[${index}].expected_answer`}
					id={`questions[${index}].expected_answer`}
					value="NO"
					register={register}
					onChangeCustom={() => {
						if (expectedAnswer) {
							if (expectedAnswer === 'YES') {
								handleSetExpectedAnswer('BOTH');
							} else if (expectedAnswer === 'BOTH') {
								handleSetExpectedAnswer('YES');
							} else {
								handleSetExpectedAnswer(undefined);
							}
						} else {
							handleSetExpectedAnswer('NO');
						}
					}}
					bgIcon={
						expectedAnswer &&
						(expectedAnswer === 'NO' || expectedAnswer === 'BOTH')
							? 'check'
							: undefined
					}
					rules={rules.expected_answer}
					error={(errors?.questions as any)?.[index]?.expected_answer}
					className="group"
					classNameButton={
						'group-hover:disabled:bg-[#F4F4F4A3] disabled:!cursor-not-allowed'
					}
				>
					No
				</InputRadioBgIcon>
			</div>
		</div>
	);
};
